module.exports = __webpack_public_path__ + "assets/img/block-hover-cae4ed8f.png";